<template>
  <div class="edit-vanity-name">
    <b-card
      class="card-container"
      body-class="border-card-info"
      header-class="border-header"
    >
      <template #header>
        <span>
          Vanity Url
        </span>
      </template>

      <div class="mt-2">
        <validation-observer ref="updateVanityName">
          <b-form-group :label="`${domain}/@${vanity_name || '...'}`">
            <validation-provider                 
                #default="{ errors }"
                name="Vanity name"
                vid="Vanity name"
                rules="required"
                >
              <b-input-group
                prepend="@"
                :class="stateVanity() === null ? '' : stateVanity() ? 'is-valid' : 'is-invalid'"
              >
                <b-form-input
                  v-model="vanity_name"
                  placeholder="Vanity name"
                  size="lg"
                  name="Vanity name"
                  :state="stateVanity()"
                />
              </b-input-group>

              <small
                class="mt-1 d-block text-danger"
                v-if="is_vanity_in_use && vanity_name"
              >
                {{ $t("vanity_in_use") }}
              </small>

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-col cols="12" class="d-flex justify-content-end p-0">
            <b-button
              variant="blue-button"
              class="mt-2 blue-button"
              :disabled="is_vanity_in_use || !vanity_name || vanity_name.length < 3"
              @click="updateVanityName"
            >
              {{ $t("save") }}
            </b-button>
          </b-col>
        </validation-observer>
      </div>
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BFormGroup,
  BInputGroup,
  BFormInput,
  BCol,
  BButton,
} from "bootstrap-vue";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import service from '@/services/others';
import { setuserData, setPermissions, getUserData } from '@/libs/utils/user';
const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');
import axios from 'axios';
import abilities from '@/libs/acl/abilities';
import config from '@/services/config';

export default {
  name: "editVanityName",

  components: {
    BCard,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BCol,
    BButton,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      vanity_name: '',
      original_vanity_name: '',
      cancel_ws: null,
      is_vanity_in_use: false,
      debounceTimer: null,
      domain: window.origin,
    };
  },
  mounted() {
    const user = getUserData()
    this.vanity_name = user?.meta_info?.vanity_name || ''
    this.original_vanity_name = this.vanity_name 
  },
  watch: {
    vanity_name(val) {
      if (!val || val.length < 3) {
        this.is_vanity_in_use = false;
        return;
      }
      if (val === this.original_vanity_name) {
        this.is_vanity_in_use = false;
        return;
      }

      clearTimeout(this.debounceTimer);

      this.debounceTimer = setTimeout(() => {
        this.isVanityInUse(val);
      }, 400);
    },
  },

  methods: {
    async isVanityInUse(vanity_name_input) {
      const CancelToken = axios.CancelToken;

      if (this.cancel_ws) this.cancel_ws();

      try {
        const response = await axios({
          method: "post",
          url: `${config.urlCore}/api/v3/profile/validate/vanity/`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          data: {
            vanity_name: vanity_name_input,
          },
          cancelToken: new CancelToken((c) => {
            this.cancel_ws = c;
          }),
        });
        this.is_vanity_in_use = response.data.response.ready_vanity_name;
      } catch (e) {
        if (!axios.isCancel(e)) {
          console.error(e);
        }
      }
    },

    stateVanity() {
      if (!this.vanity_name) return null;
      return !this.is_vanity_in_use;
    },

    updateVanityName () {
      const meta = {
        vanity_name: this.vanity_name
      }
      service.updateProfile(meta)
        .then(response => {
          this.$emit('update_profile', response)
          setPermissions(response.user);
          this.readAbility = abilities.getAbilitie(response.user) 
          
          setuserData(response, this.readAbility)
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              position: 'top-right',
              props: {
                title: this.$t('dataUpdated'),
                icon: 'CheckCircleIcon',
                variant: 'success',
                text:  this.$t('dataSuccess')
              }
            })
          })
          this.$emit('close_modal')
        }).catch(error => {
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              position: 'top-right',
              props: {
                title:  this.$t('dataError'),
                text: this.getError(error.response.data.response),
                icon: 'CoffeeIcon',
                variant: 'danger',
              }
            })
          })
        })
    },
  },
};
</script>
<style lang="scss" scoped>
.card-container {
  border-radius: 0.75rem !important;
}
.border-card-info {
  border: 0.0625rem solid rgba(222,226,230,.7);
  border-top: none;
  border-radius: 0rem 0rem 0.75rem 0.75rem;
}
.border-header {
  border: 0.0625rem solid rgba(222,226,230,.7) !important;
  border-radius: 0.75rem 0.75rem 0rem 0rem !important;
}
</style>